import {isEqual} from 'lodash';
import PropTypes from 'prop-types';
import {Component} from 'react';
import {Button, Modal} from 'semantic-ui-react';
import './CustomiseCoverPageImagesModal.scss';
import CustomiseCoverPageImagesTabWrapper from './CustomiseCoverPageImagesTabWrapper';
import {Provider} from 'react-redux';
import ReduxStore from '../ReduxStore';

export default class CustomiseCoverPageImagesModal extends Component {

	static propTypes = {
		selectedImage: PropTypes.shape({
			src: PropTypes.string,
			type: PropTypes.string,
			zoom: PropTypes.number,
			x: PropTypes.number,
			y: PropTypes.number,
		}).isRequired,
		onSave: PropTypes.func.isRequired,
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			open: false,
			selectedImage: {},
			selectionUpdated: false,
		};
	}

	close = () => this.setState({open: false});
	open = () => {
		const {selectedImage} = this.props;
		this.setState({
			open: true,
			selectedImage,
			selectionUpdated: false,
		});
	};

	isChanged = () => {
		const {selectedImage: persistedSelection} = this.props;
		const {selectedImage: modalSelection} = this.state;
		return !isEqual(persistedSelection, modalSelection);
	};

	saveAndClose = () => {
		if (this.isChanged()) {
			const {onSave} = this.props;
			onSave(this.selectedImage());
		}
		this.close();
	};

	onImageSelect = (e, {selectedImage: {src, type, zoom, x, y} = {}} = {}) => {
		this.setState({
			selectedImage: {
				src,
				type,
				zoom,
				x,
				y,
			},
			selectionUpdated: true,
		});
	};

	selectedImage = () => {
		const {selectedImage: persistedSelection} = this.props;
		const {selectedImage: modalSelection, selectionUpdated} = this.state;
		return selectionUpdated ? modalSelection : persistedSelection;
	};

	render() {
		const {open} = this.state;
		const unchanged = !this.isChanged();
		return (
			<Modal className="CustomiseCoverPageImagesModal"
						 open={open}
						 closeOnEscape
						 closeOnDimmerClick={false}
						 onClose={this.close}
						 trigger={<Button id="cover-images-trigger" primary onClick={this.open}>Edit Image</Button>}
			>
				<Modal.Header>Cover image</Modal.Header>
				<Modal.Content className="modal-content">
					<Provider store={ReduxStore}>
						<CustomiseCoverPageImagesTabWrapper selectedImage={this.selectedImage()} onSelection={this.onImageSelect}/>
					</Provider>
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={this.close}>
						Cancel
					</Button>
					<Button onClick={this.saveAndClose} primary disabled={unchanged}>
						Save
					</Button>
				</Modal.Actions>
			</Modal>
		);
	}
}